import controller from './my-profile.controller'
import template from './my-profile.html'
import './my-profile.styl'

let component = {
  restrict: 'E',
  controller,
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-profile/my-profile.component.js